/**
 * `/auth/error` — shown when the post-login refresh fails. Offers a manual route
 * back to the centralized login. The copyable details carry only what this page
 * knows (headline, time, URL): the refresh result reaches it as a boolean, so no
 * error object exists (WSRADM-0048).
 */
import { Alert } from '@mui/material';
import { ErrorDetails } from '@/components/ErrorDetails';
import { redirectToCentralizedLogin } from '@/auth/silentRefresh';
import { useCopy } from '@/hooks/useCopy';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export function AuthError() {
  const { t } = useCopy();
  const title = t('auth.errorTitle', 'Sign-in problem');
  useDocumentTitle(title);
  return (
    <main style={{ padding: '2rem', maxWidth: '32rem', margin: '0 auto' }}>
      <h1>{title}</h1>
      <Alert severity="error" sx={{ mb: 2 }}>
        {t(
          'auth.errorBody',
          'We couldn’t complete sign-in. Your session may have expired or been declined.',
        )}
        <ErrorDetails error={null} headline={title} />
      </Alert>
      <button type="button" onClick={() => redirectToCentralizedLogin('/')}>
        {t('auth.tryAgain', 'Try signing in again')}
      </button>
    </main>
  );
}
